var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.has_edited)?_c('CpButton',{staticClass:"commit-button",attrs:{"callback":_vm.commit}},[_vm._v("commit")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }